module.exports = __webpack_public_path__ + "static/img/double-ramp-8m-x-4m_256.a743319.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double-ramp-8m-x-4m_256.png
// module id = 0/y/
// module chunks = 0